export default {
    ru: {
        name: 'Имя',
        fname: 'Фамилия',
        tname: 'Отчество',
        pphoto: 'Фото паспорта',
        fphoto: 'Фото лица',
        loaded: 'Загружено',
        notLoaded: 'Не загружено',
        stepBtnNext: 'Далее',
        stepBtnSend: 'Отправить',
        stepBtnClose: 'Закрыть',
        stepTitle1: 'Заполните данные',
        stepDescription1: 'Данные должны совпадать с данными паспорта или другого удостоверения личности. Вводите данные используя исходный язык вашего документа.',
        stepTitle2: 'Фотография документа',
        stepDescription2: 'На следующем шаге сделайте фотографию вашего паспорта на странице с фотографией лица. Фотография должна быть четкой и в полном объеме.',
        stepTitle3: 'Сделайте фото',
        stepDescription3: 'Сделайте фото вашего лица. Фотография должна быть четкой и в полном объеме.',
        stepTitle4: 'Фотография лица',
        stepDescription4: 'Сделайте фотографию себя с документом. Фотография должна быть четкой и в полном объеме.',
        stepTitle5: 'Сделайте фото',
        stepDescription5: 'Сделайте фото вашего паспорта на странице с фотографией лица. Фотография должна быть четкой и в полном объеме.',
        stepTitle6: 'Проверьте данные',
        stepDescription6: 'Проверьте введенные данные. Если все верно, нажмите "Отправить".',
        stepTitle7: 'Готово',
        stepDescription7: 'Ваши данные отправлены на проверку. О результатах проверки вам придет уведомление по почте.',
    },
    en: {
        name: 'First name',
        fname: 'Middle name',
        tname: 'Last name',
        pphoto: 'Passport photo',
        fphoto: 'Face photo',
        loaded: 'Loaded',
        notLoaded: 'Not loaded',
        stepBtnNext: 'Next',
        stepBtnSend: 'Send',
        stepBtnClose: 'Close',
        stepTitle1: 'Fill in the data',
        stepDescription1: 'The data must match the data of the passport or other identity document. Enter data using the original language of your document.',
        stepTitle2: 'Upload documents',
        stepDescription2: 'On the next step, take a photo of your passport on the page with your face photo. The photo must be clear and complete.',
        stepTitle3: 'Take a photo',
        stepDescription3: 'Take a photo of your face. The photo must be clear and complete.',
        stepTitle4: 'Face photo',
        stepDescription4: 'Take a photo of yourself with the document. The photo must be clear and complete.',
        stepTitle5: 'Take a photo',
        stepDescription5: 'Take a photo of your passport on the page with your face photo. The photo must be clear and complete.',
        stepTitle6: 'Check the data',
        stepDescription6: 'Check the entered data. If everything is correct, click "Send".',
        stepTitle7: 'Done',
        stepDescription7: 'Your data has been sent for verification. You will receive a notification by email about the verification results.',
    }
}